<template>
  <div>
    <v-row>
      <v-breadcrumbs :items="breadcrumbs" large>
        <template v-slot:divider>
          <v-icon>mdi-menu-right</v-icon>
        </template>
      </v-breadcrumbs>
    </v-row>
    <v-toolbar flat>
      <v-col cols="6">
        <v-text-field
          v-model="search"
          prepend-icon="mdi-magnify"
          clearable
          label="Search invoices"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <upload-invoice-errors-button
        v-if="!noEdit"
        :invoiceBatchId="invoiceBatch.invoiceBatchId"
      ></upload-invoice-errors-button>
    </v-toolbar>
    <v-data-table
      :headers="_headers"
      :items="sessionInvoices"
      v-model="selected"
      item-key="sessionInvoiceId"
      :show-select="!Boolean(invoiceBatch.invoicedAt)"
      :search="search"
      fixed-header
      :items-per-page="-1"
      hide-default-footer
      height="70vh"
    >
      <template v-slot:[`top`]>
        <v-toolbar flat v-if="!Boolean(invoiceBatch.invoicedAt)">
          <remove-invoice-modal
            :removeOnly="true"
            :selected="selected"
            @syncInvoices="syncInvoices"
          ></remove-invoice-modal>
        </v-toolbar>
      </template>
      <template v-slot:[`item.isInvoiced`]="{ item }">
        <v-tooltip
          v-if="Boolean(invoiceBatch.invoicedAt) && !item.isInvoiced"
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="error">
              mdi-checkbox-blank-circle-outline</v-icon
            >
          </template>
          <span
            >There was an error posting this session invoice. Please contact
            support.</span
          >
        </v-tooltip>
        <v-icon v-else-if="Boolean(invoiceBatch.invoicedAt) && item.isInvoiced"
          >mdi-checkbox-marked-circle-outline</v-icon
        >
      </template>
    </v-data-table>
  </div>
</template>
<script>
import UploadInvoiceErrorsButton from "./upload-invoice-errors-button.vue";
import RemoveInvoiceModal from "./remove-invoice-modal.vue";
export default {
  props: ["noEdit"],
  components: {
    UploadInvoiceErrorsButton,
    RemoveInvoiceModal,
  },
  data() {
    return {
      headers: [
        { text: "Client", value: "clientName" },
        { text: "Client OSIS", value: "clientOsis" },
        { text: "Provider", value: "providerName" },
        { text: "Date of Service", value: "formattedDos" },
        { text: "Time", value: "startTime", sortable: false },
        { text: "Duration", value: "formattedDuration", sortable: false },
        { text: "Service", value: "service" },
        { text: "Location", value: "location" },
        { text: "Group Size", value: "groupSize" },
        { text: "Rate", value: "rate" },
        { text: "Billed Amount", value: "formattedBilledAmount" },
        { text: "Billed", value: "isInvoiced" },
      ],
      search: "",
      selected: [],
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: `Invoice Batch #${this.invoiceBatch.invoiceBatchId}`,
          to: "invoice-batches",
        },
        {
          text: `${this.invoiceBatch.formattedBatchDate}`,
        },
        {
          text: `${this.invoiceBatch.status}`,
        },
        {
          text: `${this.invoiceBatch.formattedTotalAmount}`,
        },
      ];
    },
    _headers() {
      return this.headers.filter((x) => !x.hide);
    },
    invoiceBatch() {
      return this.$store.state.billingModule.selectedInvoiceBatch;
    },
    sessionInvoices() {
      return this.invoiceBatch?.sessionInvoices;
    },
  },
  methods: {
    syncInvoices(removedInvoiceIds) {
      this.selected = this.selected.filter(
        (item) => !removedInvoiceIds.includes(item.sessionInvoiceId)
      );
    },
  },
};
</script>
